export const getId = id => id?.replaceAll(/\s/gi, '_')
